import React from "react";
import {FieldValues, UseFormRegister, FieldPath} from "react-hook-form";
import CheckboxField from "../../../ui/components/CheckboxField/CheckboxField";
import useTranslate from "../../../core/languages/hooks/useTranslate";
import {Trans} from "react-i18next";

interface LegalCheckboxProps<T extends FieldValues> {
    name: FieldPath<T>;
    register: UseFormRegister<T>;
    error?: string;
    defaultChecked?: boolean;
    onOpenModal: () => void;
    legalLinkKey: string;
}

const LegalCheckbox = React.forwardRef<HTMLInputElement, LegalCheckboxProps<any>>(({
    name,
    register,
    error,
    defaultChecked,
    onOpenModal,
    legalLinkKey,
}, ref) => {
    const t = useTranslate();
    const terms = t(legalLinkKey);

    const LabelLink = () => {
        return <span>
            <Trans
                i18nKey="common.labels.iAcceptThe"
                components={{
                    AcceptButton: <button
                        type="button"
                        onClick={() => onOpenModal()}
                        className="text-primary-600 hover:text-primary-700 underline"
                    />,
                    terms: terms,
                }}
            />
        </span>
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Prevent the user from changing the checkbox state directly
        e.preventDefault();
        if (!e.target.checked) { // Only allow unchecking, checking is only allowed through the modal
            return;
        }
        e.target.checked = false;
        onOpenModal(); // Open the modal so the user reads the document before accepting
    }

    const { onChange: registerOnChange, ...registerProps } = register(name, {required: t("common.feedback.field_required_terms", {terms: terms})});

    return (
        <div className="mt-4 mb-4">
            <CheckboxField
                ref={ref}
                name={name}
                label={<LabelLink/>}
                defaultChecked={defaultChecked}
                {...registerProps}
                onChange={handleChange}
                error={error}
            />
        </div>
    );
});

LegalCheckbox.displayName = "LegalCheckbox";

export default LegalCheckbox;
